import { render, staticRenderFns } from "./media-custom.vue?vue&type=template&id=8283f698&scoped=true&"
import script from "./media-custom.vue?vue&type=script&lang=js&"
export * from "./media-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8283f698",
  null
  
)

export default component.exports